// extracted by css-extract-rspack-plugin
export default {"content":"Nydvt5Q4ixQpWRnG","actions":"QU6UaIyY0c46MPB1"};